import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    TableRow, Tooltip, Typography
} from '@material-ui/core';
import TableCell from '../TableCell';

class SalesValueRow extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        ppsqft: PropTypes.number,
        comment: PropTypes.string,
        upliftPercent: PropTypes.number
    };

    constructor (props) {
        super(props);
    }


    render () {
        const { classes, type, ppsqft, comment, upliftPercent } = this.props;
        // This value currently needs to be calculated but there should be method to fetch from district directly
        const districtValue = (ppsqft / (1 + (upliftPercent * 0.01))).toFixed(2);

        return (
            <TableRow>
                <TableCell width="50%">
                    {type}
                </TableCell>

                <TableCell width="25%" align="left">
                    <div className={classes.sqft}>
                        <Tooltip arrow title={comment} placement="right">
                            <span variant="body2">
                                {ppsqft ? ppsqft.toFixed(2) : 'N/A'}
                            </span>
                        </Tooltip>
                        {upliftPercent && <span
                            variant="caption"
                            className={classnames(classes.chip, upliftPercent > 0 ? classes.positive : classes.negative)}
                        >
                            {upliftPercent > 0 ? '▲' : '▼'}{Math.abs(upliftPercent.toFixed(0))}%
                        </span>}
                    </div>
                </TableCell>

                <TableCell width="25%" align="right">
                    <Typography variant="body2" display="inline">
                        {districtValue ? districtValue : 'N/A'}
                    </Typography>
                </TableCell>
            </TableRow>
        );
    }
}

const style = theme => ({
    sqft: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10
        }
    },
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        borderRadius: 5,
        height: 18
    },
    positive: {
        color: theme.palette.success.main,
        background: `${theme.palette.success.main}33`
    },
    negative: {
        color: theme.palette.error.main,
        background: `${theme.palette.error.main}33`
    }
});

export default withStyles(style)(SalesValueRow);